import { render, staticRenderFns } from "./MoveToResolvedIncidentsModal.vue?vue&type=template&id=5a57dfbc&scoped=true"
import script from "./MoveToResolvedIncidentsModal.vue?vue&type=script&lang=js"
export * from "./MoveToResolvedIncidentsModal.vue?vue&type=script&lang=js"
import style0 from "./MoveToResolvedIncidentsModal.vue?vue&type=style&index=0&id=5a57dfbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a57dfbc",
  null
  
)

export default component.exports